<div >
    <div class="flex flex-col flex-auto min-w-0">
        <mat-card class=" p-4">
            <!-- Cabecero Principal -->
            <mat-card-header class="d-flex flex-column align-items-center">
                <mat-card-title>
                    <h3 class="text-primary mb-2"><strong>Carga Masiva</strong></h3>
                </mat-card-title>
                <mat-card-subtitle style="font-weight: 300;">
                    Utiliza esta interfaz para cargar catálogos de datos de forma masiva. 
                    Sigue los pasos y selecciona las opciones requeridas.
                </mat-card-subtitle>
            </mat-card-header>
            <mat-divider class="mt-3"></mat-divider>
            <mat-card-content>
                <form
                    [formGroup]="formNuevaCarga"
                    class="row d-flex justify-content-between"
                >
                    <!-- Selección de Tipo de Carga -->
                    <div class="row">
                        <div class="col-sm-12 mt-5 mb-5">
                            <mat-form-field class="custom-field" appearance="outline">
                                <mat-label>Tipo de carga</mat-label>
                                <mat-select
                                    placeholder="Seleccionar el tipo de carga"
                                    formControlName="tipoCarga"
                                    (ngModelChange)="changeTipoCarga()"
                                >
                                    <mat-option
                                        *ngFor="let tipoCarga of catTipoCarga"
                                        [value]="tipoCarga.id"
                                    >
                                        {{ tipoCarga.attributes.tipo }}
                                    </mat-option>
                                </mat-select>
                                <mat-hint>
                                    Selecciona el catálogo que deseas cargar en este proceso.
                                </mat-hint>
                                <mat-error
                                    *ngIf="formNuevaCarga.get('tipoCarga').hasError('required')"
                                >
                                    <strong>*Este campo es obligatorio</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Selección de Tipo de Proceso -->
                        <div class="col-sm-12 col-md-6" *ngIf="opcionAdicional">
                            <mat-form-field
                                class="custom-field"
                                appearance="outline"
                            >
                                <mat-label>Tipo de proceso</mat-label>
                                <mat-select
                                    placeholder="Seleccionar el tipo de proceso"
                                    formControlName="tipoProceso"
                                >
                                    <mat-option
                                        *ngFor="let tipoProceso of catTipoProceso"
                                        [value]="tipoProceso.id"
                                    >
                                        {{ tipoProceso.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <mat-hint>
                                    Indica el proceso específico para esta carga.
                                </mat-hint>
                                <mat-error
                                    *ngIf="formNuevaCarga.get('tipoProceso').hasError('required')"
                                >
                                    <strong>*Este campo es obligatorio</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Selección de Tipo de Comprobante -->
                        <div class="col-sm-12 col-md-6" *ngIf="opcionAdicional">
                            <mat-form-field
                                class="custom-field"
                                appearance="outline"
                            >
                                <mat-label>Tipo de comprobante</mat-label>
                                <mat-select
                                    placeholder="Seleccionar el tipo de comprobante"
                                    formControlName="tipoComprobante"
                                >
                                    <mat-option
                                        *ngFor="let tipoComprobante of catTipoComprobante"
                                        [value]="tipoComprobante.id"
                                    >
                                        {{ tipoComprobante.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <mat-hint>
                                    Selecciona el tipo de comprobante asociado.
                                </mat-hint>
                                <mat-error
                                    *ngIf="formNuevaCarga.get('tipoComprobante').hasError('required')"
                                >
                                    <strong>*Este campo es obligatorio</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Selección de Fecha de Emisión -->
                        <div class="col-sm-12 col-md-6" *ngIf="opcionAdicional">
                            <mat-form-field
                                class="custom-field"
                                appearance="outline"
                            >
                                <mat-label>Fecha de emisión</mat-label>
                                <mat-select
                                    placeholder="Seleccionar la fecha de emisión"
                                    formControlName="fechaEmision"
                                >
                                    <mat-option
                                        *ngFor="let fechaEmision of catFechaEmision"
                                        [value]="fechaEmision.id"
                                    >
                                        {{ fechaEmision.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <mat-hint>
                                    Indica la fecha asociada al catálogo.
                                </mat-hint>
                                <mat-error
                                    *ngIf="formNuevaCarga.get('fechaEmision').hasError('required')"
                                >
                                    <strong>*Este campo es obligatorio</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Descarga y Subida de Archivos -->
                        <div class="col-12 mt-4">
                            <!-- Contenedor personalizado para subida de archivo -->
                            <div class="file-upload-container">
                                <dx-file-uploader
                                    #fileUploader
                                    selectButtonText="Seleccionar Archivo(s)"
                                    labelText="Arrastra o selecciona tu archivo aquí"
                                    accept=".xlsx, .xlsm, .csv"
                                    [allowedFileExtensions]="['.xlsx', '.csv']"
                                    uploadMode="formNuevaCarga"
                                    [allowCanceling]="true"
                                    (onValueChanged)="submitInputFile($event, fileUploader)"
                                    class="custom-file-uploader"
                                ></dx-file-uploader>
                                <mat-hint class="upload-hint">
                                    Los formatos permitidos son: <b>CSV</b>, <b>XLSX</b>. 
                                    Asegúrate de que el archivo siga las especificaciones.
                                </mat-hint>
                            </div>
                        </div>
                        
                        <div class="col-12 mt-4">
                            <div class="">
                                <!-- Descarga de plantilla -->
                                <button
                                    mat-raised-button
                                    color="primary"
                                    class="btn-descarga"
                                    (click)="downloadTemplate()"
                                    [disabled]="!formNuevaCarga.get('tipoCarga').value"
                                >
                                    <mat-icon class="mr-2">download</mat-icon>
                                    Descargar plantilla
                                </button>
                                <br>
                                <mat-hint style="font-size: 10px;">
                                    Utiliza esta plantilla para preparar los
                                    datos que deseas cargar.
                                </mat-hint>
                            </div>
                        </div>                        
                    </div>
                </form>

                <!-- Mensaje de confirmación -->
                <div
                    *ngIf="fileCorrect"
                    class="text-center mt-3 alert alert-success"
                >
                    <strong>{{ message }}</strong>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="cerrar(0)">Cerrar</button>
    <button
        mat-flat-button
        color="accent"
        cdkFocusInitial
        (click)="insertarTarea()"
    >
        Guardar
    </button>
</div>
